import ArrayProxy from '@ember/array/proxy';
import { action } from '@ember/object';
import { setOwner } from '@ember/owner';
import { tracked } from '@glimmer/tracking';

import { GraphResultMeta } from 'rise-ui/utils/graph-result-meta.js';
import { readOnly } from 'rise-ui/utils/object/computed';
import { ResultLoader } from 'rise-ui/utils/result-loader.js';

export class GraphResult {
  static all = {
    pause: outputs => outputs.forEach(GraphResult.each.pause),
    play: outputs => outputs.forEach(GraphResult.each.play),
    toggle: (outputs, value) => (toggle => outputs
      .forEach(output => toggle(output, value))
    )(GraphResult.each.toggle),
  };
  static each = {
    pause: output => output.pause(),
    play: output => output.play(),
    toggle: (output, value) => output.toggle(value),
  };

  key;
  output;
  dates;
  @tracked loader;
  results = ArrayProxy.create({ content: [] });
  meta;
  @tracked loading = false;
  @tracked error = null;
  get paused() {
    const { loading, loader: { loadedPages } } = this;
    return loadedPages && !loading;
  }
  @readOnly('loader.complete') complete;
  constructor({
    key,
    output,
    dates,
    loader,
    meta = new GraphResultMeta(),
  }) {
    this.key = key;
    this.output = output;
    this.dates = dates;
    this.loader = loader;
    this.meta = meta;
  }
  @action pause() {
    return this.toggle(false);
  }
  @action play() {
    return this.toggle(true);
  }
  @action toggle(value) {
    if (value === undefined) {
      value = !this.loading;
    }
    if (value) {
      this.loader.clearError();
    }
    this.loading = value;
    return value;
  }
}

export function createGraphResult({
  key, output, dates,  meta, rootURL, query, mockPages, owner,
}) {
  const loader = new ResultLoader({ rootURL, query, mockPages });
  setOwner(loader, owner);
  return new GraphResult({ key, output, dates, meta, loader });
}
